import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const SelectContainer = styled.div`
  position: relative;
`

interface SelectButtonProps {
  error: boolean
}

export const SelectButton = styled.button<SelectButtonProps>`
  width: 100%;
  height: 50px;
  padding: 0.75rem 1rem;
  text-align: left;

  border: 1px solid ${props => (props.error ? 'var(--red1)' : 'var(--grey3)')};
  border-radius: 5px;

  background-color: var(--light);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.2s;
  cursor: pointer;
  outline: none;

  display: flex;
  align-items: center;
  justify-content: space-between;
`

interface SelectTextProps {
  hasValue: boolean
}

export const SelectText = styled.span<SelectTextProps>`
  color: ${props => (props.hasValue ? '#1a202c' : '#a0aec0')};
  font-size: 14px;
`

interface ArrowIconProps {
  isOpen: boolean
}

export const ArrowIcon = styled.svg<ArrowIconProps>`
  width: 1.25rem;
  height: 1.25rem;
  transition: transform 0.2s;
  transform: ${props => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  color: var(--grey2);
`

interface DropdownProps {
  isOpen: boolean
}

export const Dropdown = styled.div<DropdownProps>`
  position: absolute;
  z-index: 10;
  width: 100%;
  margin-top: 0.25rem;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  opacity: ${props => (props.isOpen ? 1 : 0)};
  visibility: ${props => (props.isOpen ? 'visible' : 'hidden')};
  transform: ${props => (props.isOpen ? 'translateY(0)' : 'translateY(-10px)')};
  transition: all 0.2s ease-in-out;
`

export const DropdownList = styled.div`
  padding: 0.25rem 0;
`

interface OptionButtonProps {
  isSelected: boolean
}

export const OptionButton = styled.button<OptionButtonProps>`
  width: 100%;
  padding: 0.5rem 1rem;
  text-align: left;
  background-color: ${props => (props.isSelected ? '#ebf8ff' : 'transparent')};
  color: ${props => (props.isSelected ? '#2b6cb0' : '#1a202c')};
  transition: background-color 0.15s;
  cursor: pointer;
  border: none;
  outline: none;
  font-size: 14px;

  &:hover {
    background-color: ${props => (props.isSelected ? '#ebf8ff' : '#f7fafc')};
  }

  &:focus {
    background-color: #f7fafc;
  }
`

export const ErrorMessage = styled.span`
  font-size: 12px;
  line-height: 18px;
  color: var(--red1);
`
